import { render, staticRenderFns } from "./editCaptcha.vue?vue&type=template&id=87d5ccc6&"
import script from "./editCaptcha.vue?vue&type=script&lang=js&"
export * from "./editCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports